'use client';

import { cn } from '@/lib/tailwind';
import type { UiScrollIndicatorProps } from './UiScrollIndicator.types';
import UiIcon from '@/components/ui/UiIcon';

function UiScrollIndicator({ targetId, className }: UiScrollIndicatorProps) {
    if (!targetId) return null;

    return (
        <button
            type="button"
            aria-label="Scroll down"
            className={cn('btn', className)}
            onClick={() => {
                const el = document.getElementById(targetId);
                if (!el) return;

                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }}
        >
            <UiIcon name="arrow-down" className="size-6" />
        </button>
    );
}

export default UiScrollIndicator;
